<template>
  <Modal :click_outside="false" @close="$emit('close')" classes="w-80 lg:w-125 bg-white px-4 lg:px-12 pb-8">
    <div class="w-full">
    <h1 class="text-main-text text-lg font-bold text-center">
      Причина замены
    </h1>
    <form class="mt-5">
      <div>
        <selectbox :isReason="true"
                   class="font-bold text-additional-text"
                   :list-items="reasonsList" v-model="reason"
                   needsInnerPadding between positionBottom
                   placeholder="Выбрать причину"
                   :arrowOnTheRight = "true"
        ></selectbox>
        <div class="mb-2 mt-4">
          <p class="faqs" v-show="this.placeholderText">Подсказка:</p>
          <p class="faqs-detail" v-show="this.placeholderText"><span v-html="placeholderText"></span></p>
        </div>
        <textarea class="rounded border border-additional-text w-full text-base  md:p-6 mt-3 pt-2 pl-4 iphone-fix"
                  v-model="form.replace_reason" style="outline: none; resize: none;" rows="9" :placeholder="'Описать подробнее'"></textarea>
        <span class="text-sm text-red pt-2 block"
              v-show="form.errors.has('replace_reason')"
              v-text="form.errors.first('replace_reason')"
        ></span>
        <span class="text-sm text-red pt-2 block"
              v-show="error_message"
              v-text="error_message"
        ></span>
        <div v-if="!on_loading || form.errors.has('replace_reason') ||error_message" class="w-full flex justify-center">
         <button :class="[isButtonDisable? 'bg-#dadada cursor-default':'bg-brand-light hover-up']"
                 :disabled="isButtonDisable"
                 @click="changeQuestion"
                 class="text-white text-sm leading-none text-center py-3 px-8 rounded-full outline-none">Заменить
          </button>
        </div>
        <div v-else class="flex justify-center">
          <font-awesome-icon v-if="on_loading || !form.errors.has('replace_reason') || !error_message"
                             class="spinner w-12 h-12 my-auto text-black text-base" :icon="['fas', 'spinner']"></font-awesome-icon>
        </div>
      </div>
    </form>
    </div>
  </Modal>
</template>
<script>
import { mapActions } from 'vuex';
import Form from 'form-backend-validation';
import Selectbox from '../../selectbox';
import client from '@/clients/partners';
import Modal from '@/views/modals/new-base-modal.vue';

export default {
  name: 'getNewQuestion',
  components: { Selectbox, Modal },
  props: ['questionId'],
  data() {
    return {
      reason: '',
      reasonsList: {
        0: {
          id: 0,
          name: 'Фактологическая ошибка',
          description: ' В вопросе есть фактологическая ошибка, противоречие.<br>' +
              '(Вопрос будет заменен в этой игре, но останется доступным<br class="hidden lg:block"> для сборки в следующую игру. К тому моменту мы проведем работу<br class="hidden lg:block">над ошибками)',
        },
        1: {
          id: 1,
          name: 'Техническая проблема',
          description: 'Нарушена верстка вопроса, не воспроизводятся медиафайлы и т.п.<br> ' +
              '(Вопрос будет заменен в этой игре, но останется доступным<br class="hidden lg:block"> для сборки в следующую игру. К тому моменту мы проведем работу<br class="hidden lg:block"> над ошибками)',
        },
        2: {
          id: 2,
          name: 'Вопрос уже был',
          description: 'Этот вопрос уже был сыгран ранее в городе.<br> (Вопрос будет удален для данного города навсегда)',
        },
        3: {
          id: 3,
          name: 'Не подходит для региона',
          description: 'Тематика или содержание вопроса не подходит аудитории.<br> (Вопрос будет удален для данного города навсегда)',
        },
        4: {
          id: 4,
          name: 'Совпадение тем вопросов',
          description: 'Вопрос с близкой вопросу тематикой уже есть в игре.<br> ' +
              '(Вопрос будет заменен в этой игре, но останется доступным<br class="hidden lg:block"> для сборки в следующую игру. К тому моменту мы проведем работу<br class="hidden lg:block"> над ошибками)',
        },
        5: {
          id: 5,
          name: 'Другое',
          description: 'Ни одна из предложенных категорий не подходит.<br> ' +
              '(Вопрос будет заменен в этой игре, но останется доступным<br class="hidden lg:block"> для сборки в следующую игру. К тому моменту мы проведем работу<br class="hidden lg:block"> над ошибками)',
        },
      },
      form: new Form({
        replace_reason: '',
        replace_reason_category: '',
      }, {
        http: client,
      }),
      on_loading: false,
      error_message: '',
      placeHolder: '',
    };
  },


  methods: {
    ...mapActions(['selectShowModal']),
    ...mapActions(['selectModalText']),
    changeQuestion() {
      this.on_loading = true;
      this.form.post(`${process.env.VUE_APP_MP_PARTNERS_BACKEND}/event-game-questions/${this.questionId}/replace`).then(() => {
        this.on_loading = false;
        this.$emit('replaced');
        this.selectModalText('Вопрос заменён'); this.selectShowModal(true);
        this.modalHolder.close();
      }).catch((error) => {
        if (error.response.status === 500) { this.error_message = error.response.data.message; }
      });
    },

  },
  computed: {
    placeholderText() {
      return this.reason && this.reasonsList[this.reason] ? this.reasonsList[this.reason].description : '';
    },
    reasonCategory() {
      return this.reason && this.reasonsList[this.reason] ? this.reasonsList[this.reason].name : '';
    },
    isButtonDisable() {
      return !this.reason || !this.form.replace_reason;
    },
  },
  watch: {
    reason() {
      this.form.replace_reason_category = this.reasonCategory;
    },
  },
};

</script>


<style scoped>
.iphone-fix {
  user-select: text;
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
}
.button-class {
  width: 40%;
  height: 3rem;
  border-radius: 28px;
  border: 1px solid rgba(151, 151, 151, 0);
  background-color: #bd006c;
}
.spinner {
  -webkit-animation:spin 4s linear infinite;
  -moz-animation:spin 4s linear infinite;
  animation:spin 4s linear infinite;
}

textarea:focus::-webkit-input-placeholder {
  color:transparent
}
@-moz-keyframes spin { 100% { -moz-transform: rotate(360deg); } }
@-webkit-keyframes spin { 100% { -webkit-transform: rotate(360deg); } }
@keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }


.faqs , .faqs-detail{
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
}
.faqs{
  color: #979797;
}
.faqs-detail{
  max-height: 120px;
  overflow: auto;
}
</style>
